
import {querydevicerecord, querydevicevoicemessage} from '../../api/device'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import BenzAMRRecorder from 'benz-amr-recorder'
export default {
name: 'voiceRecordList',
directives: {
TransferDom
},
data () {
return {
deviceData: '',
recordList: [],
voiceList: [],
openShow: false,
openTitle: '',
openIndex: 2,
amr: null,
player: new BenzAMRRecorder()
}
},
created () {
this.deviceData = this.$store.getters.get_child_obj
this.getDeviceRecord()
this.getDeviceVoice()





},
methods: {
playRecord (row) {
let vm = this
if (row.url !== null && row.url !== '') {
if (vm.amr !== null) {
if (vm.amr.isPlaying()) {
vm.amr.stop()
}
vm.amr = null
}
let url = ''
vm.amr = new BenzAMRRecorder()
if (window.location.host === 'anfangwx.aimtyiot.cn') {
let aa = row.url.split('://')
let bb = aa[1].substring(0, 18)
let cc = aa[1].substring(18)
if (bb === 'anfang.aimtyiot.cn') {
url = aa[0] + '://' + 'anfangwx.aimtyiot.cn' + cc
}
}
if (url === '') {
return
}


vm.amr.initWithUrl(url).then(function () {
vm.amr.play()

vm.recordList.forEach(function (record) {
if (record.id !== row.id) {
record.isRecord = false
} else {
record.isRecord = true
}
})
vm.$forceUpdate()
})
vm.amr.onEnded(function () {
vm.recordList.forEach(function (record) {
record.isRecord = false
})
vm.$forceUpdate()
})
}
},
stopRecord (row) {
if (this.amr !== null) {
this.amr.stop()
this.amr = null
this.recordList.forEach(function (record) {
record.isRecord = false
})
this.$forceUpdate()
}
},

getDeviceRecord () {
let data = {
imei: this.deviceData.deviceid,
did: this.deviceData.id
}
querydevicerecord(data).then(res => {
this.recordList = res.data
this.recordList.forEach(function (record) {
record['isRecord'] = false
})
console.log('recordList', this.recordList)
}).catch(() => {})
},

getDeviceVoice () {
let data = {
imei: this.deviceData.deviceid,
did: this.deviceData.id
}
querydevicevoicemessage(data).then(res => {
this.voiceList = res.data
}).catch(() => {})
},
openWindowShow (index) {
this.openIndex = index
if (index === 1) {
this.openTitle = '录音列表'
} else {
this.openTitle = '语音列表'
}
this.openShow = true
}
}
}



// WEBPACK FOOTER //
// ./src/components/device/voiceRecordList.vue